module.exports = "/assets/packs/images/c12000cbc41f6744f97539a9407d7a5c.png";